import React from "react";
// react component for multi language
import { FormattedMessage } from "react-intl";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";

// @material-ui/icons
// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";

import styles from "assets/jss/material-kit-react/views/landingPageSections/productStyle.js";

const useStyles = makeStyles(styles);

export default function Error404Section() {
  const classes = useStyles();
  return (
    <div className={classes.section}>
      <GridContainer justify="center">
        <GridItem xs={12} sm={12} md={8}>
          <h1 className={classes.title}>Oops!</h1>
          <h3 className={classes.description}>
            <FormattedMessage
              id="app.page-not-found"
              defaultMessage="Page not found."
              description="Page not found description"
            />
          </h3>
        </GridItem>
      </GridContainer>
    </div>
  );
}
